/* eslint-disable @typescript-eslint/naming-convention */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
const ChatWidgetContext = createContext(null);
// ---------------------------------------------------------------------------
// Provider
// ---------------------------------------------------------------------------
export function ChatWidgetContextProvider({ children }) {
    const [retryPrompt, setRetryPromptState] = useState(null);
    const [focusInputSignal, setFocusInputSignal] = useState(0);
    const setRetryPrompt = useCallback((prompt) => {
        setRetryPromptState(prompt);
    }, []);
    const clearRetryPrompt = useCallback(() => {
        setRetryPromptState(null);
    }, []);
    const triggerFocusInput = useCallback(() => {
        setFocusInputSignal((n) => n + 1);
    }, []);
    const value = useMemo(() => ({ retryPrompt, setRetryPrompt, clearRetryPrompt, focusInputSignal, triggerFocusInput }), [retryPrompt, setRetryPrompt, clearRetryPrompt, focusInputSignal, triggerFocusInput]);
    return React.createElement(ChatWidgetContext.Provider, { value: value }, children);
}
// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------
export function useChatWidgetContext() {
    const ctx = useContext(ChatWidgetContext);
    if (!ctx) {
        throw new Error('useChatWidgetContext must be used within a ChatWidgetContextProvider');
    }
    return ctx;
}
